// extracted by mini-css-extract-plugin
export var app = "layout-module--app--0c935";
export var appService = "layout-module--appService--acf12";